import React, {Fragment, useState, useEffect, useContext} from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {API_KEY} from "../../default_informations/api_key";
import {REFERRAL_LINK} from "../../default_informations/referral_link";
import crown_icon from "../../images/crown_icon.png";
import {Context} from "../Context/MatchesContext";

function MatchItem({match}) {
    const refLink = REFERRAL_LINK;
    const apiKey = API_KEY;
    const [thisMatch, setThisMatch] = useState([]);
    const {showModalMatchInformation} = useContext(Context);

    useEffect(() => {
        fetch(`https://api.opendota.com/api/matches/${match.match_id}?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => setThisMatch(result));

        return () => {
            setThisMatch([]);
        }
    }, [match, apiKey]);


    let start_date = match.start_time;
    let start_match = new Date(start_date * 1000);

    let year = start_match.getFullYear();
    let month = start_match.getMonth() + 1;
    if (month < 10) month = `0${month}`;
    let date = start_match.getDate();
    if (date < 10) date = `0${date}`;
    let hours = start_match.getHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = start_match.getMinutes();
    if (minutes < 10) minutes = `0${minutes}`;

    let match_date = `${date}.${month}.${year}`;
    let match_time = `${hours}:${minutes}`;

    let now_year = new Date().getFullYear();
    let now_month = new Date().getMonth() + 1;
    if (now_month < 10) now_month = `0${now_month}`;
    let now_date = new Date().getDate();
    if (now_date < 10) now_date = `0${now_date}`;

    let date_now = `${now_date}.${now_month}.${now_year}`;
    let time_now = `${new Date().getHours()}:${new Date().getMinutes()}`;

    if (match.empty_text) {
        return (
            <div className="gg-main-tournament empty-text">
                <div className="tour-header">
                    {match.empty_text}
                </div>
            </div>
        )
    }

    return (
        <div className="gg-main-tournament">
            <div className="tour-header">
                <span className={date_now === match_date && time_now < match_time ? "tour-title live" : "tour-title"}>
                    <svg className="tour-icon" width="20" height="20" viewBox="0 0 80 80">
                        <use xlinkHref="#esports_dota_2_81226" />
                    </svg>
                    {match.league_name}
                </span>
            </div>
            <div className="tour-footer">
                <div className="tour-date">
                    <Fragment>
                        <span className="time">{match_time}</span>
                        {
                            date_now === match_date ? (
                                <span className="date">Сегодня</span>
                            ) : (
                                <span className="date">{match_date}</span>
                            )
                        }
                    </Fragment>
                </div>
                <div className="tour-teams">
                    <div className={match.radiant_win ? "team first win" : "team first"}>
                        {
                            thisMatch.radiant_team ? (
                                <span className="team-logo">
                                    <LazyLoadImage
                                        src={Boolean(thisMatch.radiant_team.logo_url) ? thisMatch.radiant_team.logo_url : './img/no_team_logo.png'}
                                        alt={match.radiant_name}
                                    />
                                </span>
                            ) : null
                        }
                        <span className="team-name">{match.radiant_name}</span>
                        {
                            ((date_now === match_date && time_now > match_time) || (date_now > match_date)) ? (
                                <span className="crown_icon" style={{backgroundImage: `url(${crown_icon})`}} />
                            ) : null
                        }
                    </div>
                    <div className="with-icon">X</div>
                    <div className={!match.radiant_win ? "team second win" : "team second"}>
                        {
                            thisMatch.dire_team ? (
                                <span className="team-logo">
                                    <LazyLoadImage
                                        src={Boolean(thisMatch.dire_team.logo_url) ? thisMatch.dire_team.logo_url : './img/no_team_logo.png'}
                                        alt={match.dire_name}
                                    />
                                </span>
                            ) : null
                        }
                        <span className="team-name">{match.dire_name}</span>
                        {
                            ((date_now === match_date && time_now > match_time) || (date_now > match_date)) ? (
                                <span className="crown_icon" style={{backgroundImage: `url(${crown_icon})`}} />
                            ) : null
                        }
                    </div>
                </div>
                <div className="tour-coefficients">
                    <a className="coefficient first" href={refLink} rel="nofollow noopener noreferrer" target="_blank">{date_now === match_date && time_now < match_time ? '-' : `Счёт: ${match.radiant_score}`}</a>
                    <a className="coefficient second" href={refLink} rel="nofollow noopener noreferrer" target="_blank">{date_now === match_date && time_now < match_time ? '-' : `Счёт: ${match.dire_score}`}</a>
                </div>
                <div className="tour-info">
                    <div className="watch-tour">
                        <a className="watch_this_tour all_game" href={refLink} rel="nofollow noopener noreferrer" target="_blank">
                            <svg className="watch-icon" width="16" height="16" viewBox="0 0 357 357">
                                <use xlinkHref="#play-arrow_a9461" />
                            </svg>
                            <span>Все матчи</span>
                        </a>
                    </div>
                    <div className="watch-tour">
                        <a
                            className="watch_this_tour active"
                            href={match.match_id}
                            onClick={(e) => {
                                e.preventDefault();
                                showModalMatchInformation(thisMatch);
                            }}
                        >
                            <svg className="hide-icon" width="16" height="16" viewBox="0 0 10 16">
                                <use xlinkHref="#arrow-left_3c6dd" />
                            </svg>
                            <span>Подробнее</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MatchItem;